var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Avatar",style:(_vm.style)},[(!_vm.avatar)?_c('span',[_vm._v("\n    "+_vm._s(_vm.initials)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }